import { getAuthenticated } from '../../../../services/RestTemplate';
import { objToUrlParams } from '../../../../shared/helpers/url-params.helper';

export function getPlayers(args) {
    const params = objToUrlParams(args);
    const playersUrl = '/players' + params;

    return getAuthenticated(playersUrl);
}
